import { FixMeLater } from "../../assessments/components/GlobalErrorMessage";

export const REQUEST_CATEGORY       = '[category] request';
export const SET_CATEGORY  = '[category] set';

export const requestCategory = (assessmentCriteria : FixMeLater) => ({
  type: REQUEST_CATEGORY,
  payload: { assessmentCriteria }
});
